import axios from '@/configs/axios'

const endpoints = {
  auth: `${process.env.VUE_APP_API}/auth`,
  allRanks: 'https://www.mocky.io/v2/5cbb509c310000f9204d74dd',
  signups: `${process.env.VUE_APP_API}/signups`,
  users: `${process.env.VUE_APP_API}/users`,
  events: `${process.env.VUE_APP_API}/events`,
  divisions: `${process.env.VUE_APP_API}/divisions`,
  invites: `${process.env.VUE_APP_API}/invites`,
  pwdRecovery: `${process.env.VUE_APP_API}/pwd`,
  logs: `${process.env.VUE_APP_API}/logs`
}

export default {
  'GET': {
    signupSession: async () => {
      return axios.get(`${endpoints.signups}/create-session`)
    },
    divisions: {
      all: async () => {
        return axios.get(`${endpoints.divisions}/all`)
      },
      active: async (data) => {
        let url = `${endpoints.divisions}/?active=true`

        if ('eventId' in data) {
          url += `&eventId=${data.eventId}`
        }

        return axios.get(url)
      },
      judge: async (data) => {
        return axios.get(`${endpoints.divisions}/judge?userId=${data.userId}`)
      }
    },
    auth: {
      pwdReset: async (recoveryId) => {
        return axios.get(`${endpoints.pwdRecovery}/${recoveryId}`)
      }
    },
    //  Stripe
    stripe: {
      paymentIntent: async (data) => {
        return axios.get(`${process.env.VUE_APP_API}/stripe/payment-intent`, {
          params: data
        })
      }
    },
    users: {
      signups: async () => {
        return axios.get(`${endpoints.users}/u?role=participant&completedPayment=true`)
      },
      all: async (data) => {
        let queryString = []
        if (typeof data !== 'undefined') {
          if ('query' in data) {
            if ('type' in data.query) {
              queryString.push(`role=${data.query.type}`)
            } else {
              queryString.push('role=all')
            }

            if ('status' in data.query) {
              queryString.push(`status=${data.query.status}`)
            }
          } else {
            queryString.push('role=all')
          }

          if ('eventId' in data) {
            queryString.push(`eventId=${data.eventId}`)
          }
        }
        queryString = queryString.join('&')
        return axios.get(`${endpoints.users}/u?${queryString}`)
      },
      current: async () => {
        return axios.get(`${endpoints.users}/u`)
      },
      single: async (id) => {
        return axios.get(`${endpoints.users}/u/${id}`)
      },
      divisions: async (data) => {
        return axios.get(`${endpoints.users}/u/divisions/all?eventId=${data.eventId}`)
      },
      division: async (data) => {
        let url = `${endpoints.users}/u/divisions/${data.divisionId}/${data.eventId}`
        if ('userId' in data) {
          url += `?user=${data.userId}`
        }
        return axios.get(url)
      }
    },
    submissions: {
      all: async (data) => {
        return axios.get(`${endpoints.divisions}/submissions?eventId=${data.eventId}`)
      },
      judge: async (data) => {
        return axios.get(`${endpoints.divisions}/submissions?user=judge&eventId=${data.eventId}`)
      },
      leaderboard: async (data) => {
        return axios.get(`${endpoints.divisions}/submissions?user=participant&eventId=${data.eventId}`)
      },
      single: async (divisionId) => {
        return axios.get(`${endpoints.divisions}/submission/${divisionId}`)
      }
    },
    events: {
      all: async () => {
        return axios.get(endpoints.events)
      },
      active: async () => {
        return axios.get(`${endpoints.events}/?active=true`)
      }
    },
    invite: async (inviteId) => {
      return axios.get(`${endpoints.invites}/${inviteId}`)
    },
    logs: async () => {
      return axios.get(endpoints.logs)
    }
  },
  'POST': {
    profile: async (data) => {
      return axios.post(endpoints.users, data)
    },
    judge: async (data) => {
      return axios.post(`${endpoints.invites}/create`, data)
    },
    auth: {
      login: async (data) => {
        return axios.post(`${endpoints.auth}/login`, data)
      },
      pwdReset: async (data) => {
        return axios.post(`${endpoints.pwdRecovery}/`, data)
      },
      recoverPwd: async (data) => {
        return axios.post(`${endpoints.pwdRecovery}/recover`, data)
      }
    },
    events: async (data) => {
      return axios.post(endpoints.events, data)
    },
    divisions: async (data) => {
      return axios.post(endpoints.divisions, data)
    },
    invite: async (data) => {
      return axios.post(endpoints.invites, data)
    },
    users: {
      support: async (data) => {
        return axios.post(`${endpoints.users}/u/support`, data)
      }
    }
  },
  'PUT': {
    profileDivisions: async (data) => {
      return axios.put(`${endpoints.users}/divisions`, data)
    },
    events: {
      updateOne: async (data) => {
        return axios.put(endpoints.events, data)
      },
      updateDivisions: async (data) => {
        return axios.put(`${endpoints.events}/divisions`, data)
      }
    },
    divisions: {
      updateOne: async (data) => {
        return axios.put(endpoints.divisions, data)
      },
      updateEvents: async (data) => {
        return axios.put(`${endpoints.divisions}/events`, data)
      }
    },
    users: {
      update: async (data) => {
        return axios.put(`${endpoints.users}/`, data)
      },
      updateDivisions: async (data) => {
        return axios.put(`${endpoints.users}/divisions`, data)
      }
    },
    submissions: {
      saveGrades: async (data) => {
        return axios.put(`${endpoints.divisions}/submissions`, data)
      },
      saveVideo: async (data) => {
        return axios.put(`${endpoints.divisions}/submissions/submit-yt`, data)
      }
    }
  },
  'DELETE': {
    events: async (data) => {
      return axios.delete(endpoints.events, { data: data })
    },
    submissions: async (data) => {
      return axios.delete(`${endpoints.divisions}/submission/`, { data: data })
    }
  }
}
